// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApkLoanKKBFinancial1Service = {};

ApkLoanKKBFinancial1Service.convertFlatToEffectiveService = function (data) {
  return lossClient({
    url: `/ApkLoanKKBFinancial1/convert-flat-to-effective`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKKBFinancial1Service.convertEffectiveToFlatService = function (data) {
  return lossClient({
    url: `/ApkLoanKKBFinancial1/convert-effective-to-flat`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKKBFinancial1Service.interestamountService = function (data) {
  return lossClient({
    url: `/ApkLoanKKBFinancial1/interestamount`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKKBFinancial1Service.frominstallmentService = function (data) {
  return lossClient({
    url: `/ApkLoanKKBFinancial1/frominstallment`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKKBFinancial1Service.simulateService = function (data) {
  return lossClient({
    url: `/ApkLoanKKBFinancial1/regular-interest-amortization`,
    method: "post",
    headers: {},
    data: data,
  });
};

export default ApkLoanKKBFinancial1Service;
